
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../../commons/form/InputText'
import InputSelect from '../../../commons/form/InputSelect'
import { handleKeyDown } from '../../../../util/utils'

class ProcessingAgencyIntegrationServiceDestinationsMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.processingAgencyServiceDestination)
    }
  }

  submitProcessingAgencyServiceDestination (values) {
    const processingAgencyServiceDestination = {
      ProcessingAgencyServiceDestinationId: this.props.processingAgencyServiceDestination?.processingAgencyServiceDestinationId,
      ProcessingAgencyId: this.props.agency.processingAgencyId,
      DestinationUseValue: values.destinationUseValue,
      ServiceDestinationId: values.serviceDestinationId
    }

    this.props.actions.submitProcessingAgencyServiceDestinations(this.props.agency.processingAgencyId, processingAgencyServiceDestination)
  }

  render () {
    const {
      t, handleSubmit,
      showModal
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.SERVICE_DESTINATIONS.'
    return (
      <Modal id="processingAgencyIntegrationServiceDestinationsMasterModal" className="_nf" show={showModal} onHide={() => this.props.actions.showProcessingAgencyServiceDestinationsModal(null, false)} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitProcessingAgencyServiceDestination.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={() => this.props.actions.showProcessingAgencyServiceDestinationsModal(null, false)}>
            <Modal.Title>{t(`${tKey}SERVICE_DESTINATION`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="serviceDestinationId"
                controlLabel={t(`${tKey}SERVICE_DESTINATION`)}
                placeholder={t(`${tKey}SERVICE_DESTINATION`)}
                valueKey="id"
                labelKey="value"
                options={this.props.combos.serviceDestinations}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="destinationUseValue"
                controlLabel={t(`${tKey}PROCESSING_AGENCY_CODE`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY_CODE`)}
                required={[true]}
                maxLength={50}
                colSm={0}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}MODAL.SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyServiceDestinationModal',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.DOC_TYPE_USES.VALIDATION.'
    if (!values.serviceDestinationId) {
      error.serviceDestinationId = props.t(`${tKey}VALUE_REQUIRED`)
    }
    if (!values.destinationUseValue) {
      error.destinationUseValue = props.t(`${tKey}VALUE_REQUIRED`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(ProcessingAgencyIntegrationServiceDestinationsMasterModal)
